import * as React from 'react';
import { ClearDiv } from '..';

export interface IColHalvesProps {
	Col1: any;
	Col2: any;
}

export class ColHalves extends React.PureComponent<IColHalvesProps, {}> {
	public render() {
		return (
			<ClearDiv className='row' clearHeightMobile='0'>
				<div className='col-lg-6 col-sm-12'>{this.props.Col1}</div>
				<div className='col-lg-6 col-sm-12'>{this.props.Col2}</div>
			</ClearDiv>
		);
	}
}
